import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-planting-instructions-form',
  templateUrl: './planting-instructions-form.component.html',
  styleUrls: ['./planting-instructions-form.component.css']
})
export class PlantingInstructionsFormComponent implements OnInit {

  @Input('treatment') public treatmentFormGroup: FormGroup;
  @Input('numberOfSeedsPerCell') public numberOfSeedsPerCellControl: FormControl;
  @Input() public isWheatRequest: boolean;

  public get plantingInstructions(): FormGroup {
    const form = <FormGroup>this.treatmentFormGroup.get('plantingInstructions');
    return form;
  }

  public get indexing(): boolean {
    return this.plantingInstructions.value.indexing;
  }

  public get numberOfSeedsPerCell(): number {
    return this.numberOfSeedsPerCellControl.value;
  }

  public get numberToStart(): number {
    return this.plantingInstructions.value.numberToStart;
  }

  public get numberToPots(): number {
    return this.plantingInstructions.value.numberToPots;
  }

  public get numberToHarvest(): number {
    return this.plantingInstructions.value.numberToHarvest;
  }

  public get numberToStartControl(): FormControl {
    return this.plantingInstructions.get('numberToStart') as FormControl;
  }

  public get numberToPotsControl(): FormControl {
    return this.plantingInstructions.get('numberToPots') as FormControl;
  }

  public get numberToHarvestControl(): FormControl {
    return this.plantingInstructions.get('numberToHarvest') as FormControl;
  }

  constructor() {
  }

  ngOnInit() {
  }

  public copyValueFrom(copyArgs: PlantingInstructionCopyArgs) {
    this.plantingInstructions.patchValue(copyArgs);
    this.plantingInstructions.updateValueAndValidity();
  }
}

export interface PlantingInstructionCopyArgs {
  numberToPots: number;
  numberToHarvest: number;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/planting-instructions/planting-instructions-form/planting-instructions-form.component.ts